import React from "react";
import { useDispatch, useSelector } from "react-redux";
import WarningIcon from "@material-ui/icons/Warning";
import classNames from "classnames";

import { Dialog } from "../Dialog/Dialog";
import { Button, colorFirm } from "../../Buttons/Button/Button";
import { userActionSelector } from "../../../services/UserActionConfirm/selectors";
import { closeUserAction } from "../../../services/UserActionConfirm/actions";
import { USER_ACTION_DIALOG_TYPE } from "../../../services/UserActionConfirm/constants";

import "./UserActionDialog.scss";

const DEFAULT_PROCEED_BUTTON_PROPS = { proceedText: "OK" };
const DEFAULT_CANCEL_BUTTON_PROPS = { cancelText: "Cancel" };

export const UserActionDialog = () => {
    const dispatch = useDispatch();
    const {
        isLoading,
        isOpen,
        actionSubject,
        actionType,
        action,
        message,
        dialogType,
        actionsProps
    } = useSelector(userActionSelector);

    const { proceedText, ...restProceedButtonProps } = actionsProps?.proceedButtonProps || DEFAULT_PROCEED_BUTTON_PROPS;
    const { cancelText, ...restCancelButtonProps } = actionsProps?.cancelButtonProps || DEFAULT_CANCEL_BUTTON_PROPS;


    const isErrorType = dialogType === USER_ACTION_DIALOG_TYPE.Error;

    const handleSubmit = () => {
        try {
            action();

            dispatch(closeUserAction());
        } catch(err) {
            console.log(err);
        }
    };

    const handleClose = () => {
        dispatch(closeUserAction());
    };

    return (
        <Dialog
            classes={{ root: "user-action", paper: "user-action__inner" }}
            title={(
                `Are you sure you want to ${actionType} ${actionSubject}?`
            )}
            isOpen={isOpen}
            onClose={handleClose}
            buttons={
                <>
                    <Button
                        onClick={handleSubmit}
                        disabled={isLoading}
                        colorFirm={2}
                        {...restProceedButtonProps}
                    >
                        {proceedText}
                    </Button>

                    <Button
                        onClick={handleClose}
                        colorFirm={colorFirm.firm3}
                        disabled={isLoading}
                        {...restCancelButtonProps}
                    >
                        {cancelText}
                    </Button>
                </>
            }
        >
            <div className="user-action__body">
                {
                    isErrorType && (
                        <WarningIcon className="user-action__body-icon" />
                    )
                }

                {
                    message && (
                        <div className={classNames("user-action__message", { "user-action__message--error": isErrorType })}>{message}</div>
                    )
                }
            </div>
        </Dialog>
    );
};
